import { put, takeLatest } from "redux-saga/effects";
import { getNotificationDetailApi } from "store/api/NotificationApi";
import { GET_NOTIFICATION_DETAIL_ACTION } from "../../actions/NotificationPageAction/actionTypes";

import * as notificationPageAction from "../../actions/NotificationPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getNotificationDetail(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield getNotificationDetailApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(
				notificationPageAction.setNotificationDetailAction(res?.data)
			);
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getNotificationDetailSaga() {
	yield takeLatest(GET_NOTIFICATION_DETAIL_ACTION, getNotificationDetail);
}

export default getNotificationDetailSaga;
